<template>
  <div class="frame-page">
    <iframe :src="url"></iframe>
  </div>
</template>

<script>
export default {
  name: 'FramePage',
  data() {
    return {
      url: decodeURIComponent(this.$route.query.url || '')
    };
  },
  watch: {
    $route(route) {
      if (route.query.url) {
        this.url = decodeURIComponent(route.query.url || '');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.frame-page {
  width: 100%;
  height: 100%;
  display: flex;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
